import type { GeneratedContent, EvaluationType_Option } from "../types";

interface ObjectiveQuestionsProps {
  content: GeneratedContent;
  evaluationTypes: EvaluationType_Option[];
}

export const ObjectiveQuestions: React.FC<ObjectiveQuestionsProps> = ({
  content,
  evaluationTypes,
}) => {
  const questoes = content.estrutura_avaliacao?.questoes_objetivas;

  if (!questoes || !questoes.exemplos || questoes.exemplos.length === 0) {
    return null;
  }

  return (
    <div className="mb-8">
      <h3 className="section-title text-lg font-bold text-indigo-900 mb-6 pb-3 border-b-2 border-indigo-700">
        Parte I - Questões Objetivas ({questoes.valor_cada} pontos cada)
      </h3>

      {questoes.exemplos.map((questao: any, idx: number) => (
        <div key={idx} className="question-block mb-6">
          <p className="font-semibold text-gray-900 mb-3">
            <span className="bg-indigo-100 text-indigo-900 px-3 py-1 rounded-full mr-2">
              {questao.numero}
            </span>
            {questao.enunciado}
          </p>
          <div className="ml-8 space-y-2">
            {questao.alternativas?.map((alt: string, altIdx: number) => (
              <p key={altIdx} className="text-gray-800">
                <input type="radio" disabled className="mr-2" />
                {alt}
              </p>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
